import { SMSDataType, SMSSortField } from 'types/sms.type';
import axiosInstance from './config/api';
import { SortDirection } from 'types/call.type';

export type SMSDataParams = {
    perPage?: number;
    currentPage?: number;
    id?: string;
    sortOrder?: SortDirection;
    sortBy?: SMSSortField;
    search?: string;
    smsStatus?: string;
    nodeStatus?: string;
    conversationState?: string;
    nodeSubStatus?: string;
    // 'true' keeps conversations with at least one inbound message, 'false' only
    // those with none. Empty string means no filter, matching the other filters.
    hasResponse?: string;
    partyStage?: string;
    startDate?: Date;
    endDate?: Date;
    overDue?: boolean;
};

export type SMSDataResponse = {
    data: SMSDataType[];
    pagination: {
        totalPages: number;
        totalRecords: number;
        currentPage: number;
        perPage: number;
    };
};

export type SMSConversationMessagesParams = {
    conversationId: string;
};

export const getSMSData = async ({ id, ...rest }: SMSDataParams) => {
    const params = {
        ...rest,
        workflowId: id,
    };
    const { data } = await axiosInstance.get<SMSDataResponse>('/sms/conversations', { params });
    return data;
};

export const getSMSConversationMessages = async ({ conversationId }: SMSConversationMessagesParams) => {
    const { data } = await axiosInstance.get<SMSDataResponse>(`/sms/conversations/${conversationId}/messages`);
    return data;
};
